/**
 * User-facing credit debits — one wallet balance covers all billable actions.
 * Fractional values supported (balance stored as NUMERIC in DB).
 */
export const USER_CREDIT_COSTS = {
  resume_optimize: 3,
  job_feed_refresh: 1,
  cover_letter: 2,
  application_letter: 2,
  agent_chat: 0.5,
  match_explanation: 1,
  exa_search: 1,
  skill_assessment: 1.5,
  interview_questions: 1.5,
} as const;

export type UserCreditOperation = keyof typeof USER_CREDIT_COSTS;

export function getCreditCost(operation: UserCreditOperation): number {
  return USER_CREDIT_COSTS[operation];
}

/** Server-authoritative grant amounts per pack (must match create-cashfree-order). */
export const PACK_GRANT_CREDITS: Record<string, number> = {
  'pack-monthly': 60,
  'pack-quarterly': 180,
  'pack-halfyearly': 360,
  'pack-daypass': 5,
  'pack-weekly': 20,
};
